import { Flows } from '../../flows/flows';
import type { Context, Events } from '../../machine/types';
import type { Flow } from '../../types/flows/Flow';

import { isValidFlowName } from './isValidFlowName';

export const getFlow = (flow: string | null): Flow<Context, Events> | undefined => {
  if (!flow || !isValidFlowName(flow)) {
    return undefined;
  }

  return Flows[flow];
};
